import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useRepository } from '@/ui/state/repositoryContext'
import {
  listProjects,
  type ProjectSummary,
} from '@/application/library/listProjects'
import { ProjectCard } from '@/ui/components/ProjectCard'
import { UploadButton } from '@/ui/components/UploadButton'
import { SampleProjectButton } from '@/ui/components/SampleProjectButton'
import { MobileNotice } from '@/ui/components/MobileNotice'
import { useMediaQuery } from '@/ui/hooks/useMediaQuery'

export function LibraryRoute() {
  const { t } = useTranslation()
  const repo = useRepository()
  const [summaries, setSummaries] = useState<ProjectSummary[] | null>(null)
  const isMobile = useMediaQuery('(max-width: 767px)')

  useEffect(() => {
    let cancelled = false
    void listProjects(repo).then((s) => {
      if (!cancelled) setSummaries(s)
    })
    return () => {
      cancelled = true
    }
  }, [repo])

  if (summaries == null) {
    return (
      <main className="mx-auto max-w-3xl px-6 py-12">
        <p style={{ color: 'var(--color-muted)' }}>…</p>
      </main>
    )
  }

  if (summaries.length === 0) {
    return (
      <main className="mx-auto max-w-2xl px-6 py-16 flex flex-col gap-8">
        {isMobile && <MobileNotice />}
        <header>
          <h1
            className="text-4xl font-medium"
            style={{ fontFamily: 'var(--font-display)' }}
          >
            {t('upload.label')}
          </h1>
          <p className="mt-2 text-sm" style={{ color: 'var(--color-muted)' }}>
            {t('upload.hint')}
          </p>
        </header>
        {!isMobile && <UploadButton />}
        <SampleProjectButton />
      </main>
    )
  }

  return (
    <main className="mx-auto max-w-3xl px-6 py-12 flex flex-col gap-8">
      {isMobile && <MobileNotice />}
      <header className="flex items-baseline justify-between">
        <h1
          className="text-3xl font-medium"
          style={{ fontFamily: 'var(--font-display)' }}
        >
          {t('library.title')}
        </h1>
        {!isMobile && <UploadButton label={t('library.newProject')} />}
      </header>

      <ul className="grid gap-3 list-none p-0">
        {summaries.map((s) => (
          <li key={s.project.id}>
            <ProjectCard summary={s} />
          </li>
        ))}
      </ul>
    </main>
  )
}
